export default "__VITE_ASSET__CxkcQhDn__"